import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { IActivity } from '../../../Activity/interface/IActivity'
import { PersonKnowledge } from '../util/PersonKnowledge'

import { KnowledgeTableBody } from './KnowledgeTableBody'
import { KnowledgeTableHead } from './KnowledgeTableHead'
import { NoDataText, TableContainer } from './style'

type Props = {
  userUuid: string
  personKnowledgeFromLocalStore: PersonKnowledge[]
  activityList: IActivity[]
  windowWidth: number
}

export const KnowledgeTable: React.FC<Props> = ({
  windowWidth,
  personKnowledgeFromLocalStore,
  activityList,
}) => {
  const { t } = useTranslation()

  return (
    <TableContainer windowWidth={windowWidth}>
      <KnowledgeTableHead
        windowWidth={windowWidth}
        knowledgeData={personKnowledgeFromLocalStore}
      />
      {personKnowledgeFromLocalStore.length !== 0 ? (
        <KnowledgeTableBody
          knowledgeData={personKnowledgeFromLocalStore}
          windowWidth={windowWidth}
          activityList={activityList}
        />
      ) : (
        <NoDataText>
          🎓 {t(`There are currently no knowledge activities`)}
        </NoDataText>
      )}
    </TableContainer>
  )
}
